<template>
   <div class="modal_card reverse">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Скачать протокол</h1> 

      <form @submit.prevent="$emit('handle-change')">
        <ul class="course-categories">
          <b-collapse animation="" :open="true">
            <li @click="open" class="list_header categories active" slot="trigger" aria-controls="right-categories-list">
              <span class="left"> <i class="icon-button-arrow"></i>Комиссия </span>
            </li>
            <div>
              <li :key="commission.name + i" class="list_header course" v-for="(commission, i) in commissionsList.data" >
                <span class="right">
                  <b-field class="input_checkbox">
                    <b-checkbox
                      v-model="selectedCommission"
                      :true-value="commission.id"
                      :false-value="null"
                      :native-value="commission.id"
                      type="is-info">
                        {{ commission.name }}
                    </b-checkbox>
                  </b-field>
                </span>
              </li>
              <b-pagination
                :total="commissionsList.total || 1" 
                :simple="true"
                :size="'is-small'"
                :order="'is-right'"
                @change="$emit('change-page')" 
                :per-page="15">
              </b-pagination>
            </div>
          </b-collapse>
        </ul>
    
        <button
          @click="$emit('download', selectedCommission)"
          class="add_user_button modal_button left_button"
          type="submit"
          :disabled="!selectedCommission || errors.items.length > 0">
          Скачать
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commission: {
      default: () => {},
      type: Object
    },
    commissionsList: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isOpen: true,
      search: {
        name: '',
        commission_id: 0
      },
      selectedCommission: null,
    }
  },
  methods: {
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    },
  }
}
</script>
